import { parseISO } from 'date-fns';

export const parseDate = (value: string | Date | null | undefined, defaultValue = new Date()): Date => {
    return typeof value === 'string'
        ? parseISO(!value.match(/z$/gi) ? `${value}Z` : value)
        : value instanceof Date
          ? value
          : defaultValue;
};
